/**
 * Mapping of browser name values to strings to display in the UI
 */
export const browserNameMap = {
  chrome: 'Google Chrome',
};
